/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Services_Svc_Full_LabelInputs */

const en_services_svc_full_label = /** @type {(inputs: Services_Svc_Full_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Full systems`)
};

const lv_services_svc_full_label = /** @type {(inputs: Services_Svc_Full_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pilnas sistēmas`)
};

/**
* | output |
* | --- |
* | "Full systems" |
*
* @param {Services_Svc_Full_LabelInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const services_svc_full_label = /** @type {((inputs?: Services_Svc_Full_LabelInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Services_Svc_Full_LabelInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_services_svc_full_label(inputs)
	return en_services_svc_full_label(inputs)
});